import axios from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { API_URL, USER } from 'src/api';
import { handleErrorToast, handleSuccessToast } from 'src/components/molecules';

export function useRemoveUserMutation() {
  const queryClient = useQueryClient();

  const { mutate: removeUser } = useMutation({
    mutationFn: (id: string) => axios.delete(`${API_URL}${USER(id)}`),
    onSuccess: () => {
      queryClient.invalidateQueries('SearchUsersPaginated');
      handleSuccessToast({ toastMessage: 'User Deactivated Successfully' });
    },
    onError: (err: {
      response: { data: { errors: { message: string }[] } };
    }) => {
      const error = err?.response?.data?.errors[0]?.message
        ? err.response.data.errors[0].message
        : 'Something went wrong, could not deactivate user';
      handleErrorToast({ toastMessage: `${error}` });
    },
  });

  return removeUser;
}
